import React from "react";
import { ListGroupItem } from "react-bootstrap";
import { EMOJI_BY_CODE_MAP, MESSAGE_EMOJI_SRC } from "../../../../../platform/src/constants/components/emoji";

import './ReactionTable.scss';

export default ({reactions}) => {
    return (
        <div className="reactions-table">
            {reactions?.map(({hash, quantity}) => {
                if (!EMOJI_BY_CODE_MAP[hash]) {
                    return null;
                }

                return (
                    <ListGroupItem key={hash} className="reactions-table--item">
                        <img src={MESSAGE_EMOJI_SRC(hash)} alt="" />
                        <div className="reactions-table--item--quantity">{quantity}</div>
                    </ListGroupItem>
                );
            })}
        </div>
    );
}
